export default "__VITE_ASSET__DgWcDeoq__"